(() => {
  const MOTION_CLASSES = [
    'brx-motion-in-next',
    'brx-motion-out-next',
    'brx-motion-in-prev',
    'brx-motion-out-prev',
  ];

  const initHeroMotion = (root) => {
    if (!root || root.dataset.brxMotionReady === 'true') return;

    const slides = [...root.querySelectorAll('[data-brx-hero2-slide]')];
    if (!slides.length) return;

    root.dataset.brxMotionReady = 'true';
    let previousIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let cleanupTimer = null;

    const prepareVideo = (video) => {
      if (!video) return;

      video.preload = 'auto';
      video.setAttribute('preload', 'auto');
      video.muted = true;
      video.playsInline = true;

      const markReady = () => video.classList.add('brx-video-ready');

      if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
        markReady();
      } else {
        video.addEventListener('loadeddata', markReady, { once: true });
        video.addEventListener('canplay', markReady, { once: true });
      }

      if (video.readyState === HTMLMediaElement.HAVE_NOTHING && video.networkState === HTMLMediaElement.NETWORK_EMPTY) {
        video.load();
      }

      video.play().catch(() => {});
    };

    const prepareActiveVideo = (index) => {
      const activeVideo = slides[index]?.querySelector('video');
      prepareVideo(activeVideo);

      // Keep the following slide lightweight. Its metadata/poster can be prepared,
      // but the full video payload is only promoted to preload=auto once active.
      if (slides.length > 1) {
        const nextIndex = (index + 1) % slides.length;
        const nextVideo = slides[nextIndex]?.querySelector('video');
        if (nextVideo && nextVideo !== activeVideo && nextVideo.readyState === HTMLMediaElement.HAVE_NOTHING) {
          nextVideo.preload = 'metadata';
          nextVideo.setAttribute('preload', 'metadata');
        }
      }
    };

    prepareActiveVideo(previousIndex);

    if (slides.length < 2) return;

    const navControls = [
      ...root.querySelectorAll('[data-brx-hero2-prev], [data-brx-hero2-next], [data-brx-hero2-dot]'),
    ];

    navControls.forEach((control) => {
      let pointerActivated = false;

      control.addEventListener('pointerdown', () => {
        pointerActivated = true;
      }, { passive: true });

      control.addEventListener('keydown', () => {
        pointerActivated = false;
      });

      control.addEventListener('click', () => {
        if (!pointerActivated) return;
        pointerActivated = false;

        // Pointer clicks should not leave the hero paused by its focus handler.
        // Keyboard users keep focus, while mouse/touch users immediately release it.
        window.requestAnimationFrame(() => control.blur());
      });
    });

    const clearMotionClasses = () => {
      slides.forEach((slide) => slide.classList.remove(...MOTION_CLASSES));
    };

    const observer = new MutationObserver(() => {
      const currentIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (currentIndex < 0 || currentIndex === previousIndex) return;

      prepareActiveVideo(currentIndex);

      if (cleanupTimer) window.clearTimeout(cleanupTimer);
      clearMotionClasses();

      const oldSlide = slides[previousIndex];
      const newSlide = slides[currentIndex];
      const lastIndex = slides.length - 1;

      let direction = 'next';
      if (previousIndex === 0 && currentIndex === lastIndex) direction = 'prev';
      else if (previousIndex === lastIndex && currentIndex === 0) direction = 'next';
      else if (currentIndex < previousIndex) direction = 'prev';

      oldSlide?.classList.add(direction === 'next' ? 'brx-motion-out-next' : 'brx-motion-out-prev');
      newSlide?.classList.add(direction === 'next' ? 'brx-motion-in-next' : 'brx-motion-in-prev');

      previousIndex = currentIndex;

      cleanupTimer = window.setTimeout(() => {
        clearMotionClasses();
      }, 780);
    });

    observer.observe(root, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'hidden'],
    });
  };

  const initAll = () => {
    document.querySelectorAll('[data-brx-hero2]').forEach(initHeroMotion);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();